import { authService } from "../services/api";
import { uiLogger } from "./logger";

/**
 * Redirect to the portal app with fresh authentication tokens
 */
export async function redirectToApp(): Promise<void> {
    try {
        // Small delay to ensure Cognito session is fully established
        await new Promise((resolve) => setTimeout(resolve, 100));

        const token = await authService.getJwtToken();
        const adminBaseUrl = import.meta.env.VITE_ADMIN_BASE_URL;

        if (token && adminBaseUrl) {
            let appUrl = `${adminBaseUrl}?token=${token}`;
            window.location.href = appUrl;
        } else {
            uiLogger.error("Missing token or admin base URL");
        }
    } catch (error) {
        uiLogger.error("App navigation error:", error);
    }
}
